import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navBack } from 'utils/navigation';
import SafeArea from '../SafeArea';
import bbtNative from '@bbtfe/native';
import './index.scss';

class Header extends Component {
  render() {
    const { userAgent = {}, router = {} } = this.props;
    const { location = {} } = router;
    const { navigation_bar_hidden, is_hide_titlebar = 0 } = location.query || {};
    const { pregnancy, MikaInCar } = userAgent;
    if (pregnancy && !navigation_bar_hidden) return null;
    if (MikaInCar && !navigation_bar_hidden) return null;
    //隐藏h5的titlebar
    if (Number(is_hide_titlebar) === 1) return null;
    // app内切隐藏app头
    return (
      <div id='component-header' className={this.props.className}>
        {this.props.placeholder ? null : (
          <div
            className={`component-header-fixed${
              this.props.showBorder ? ' hasBorder' : ''
            }${this.props.showShadow ? ' hasShadow' : ''}`}
            style={this.props.currentStyle ?? {}}
          >
            <SafeArea position='top' />
            <div className='component-header-main'>
              <div className='component-header-left-wrapper'>
                <div onClick={() => this.props.backCB()} className='back-node-div'>
                  {this.props.showBack ? (this.props.backNode ?? <span
                    className='iconfont icon-back component-header-back'
                  />) : null}
                  <span className='mika-in-car-back'>{MikaInCar ? (this.props.backText || '返回') : null}</span>
                </div>
                {this.props.leftChild ? this.props.leftChild : null}
              </div>
              <div className='component-header-title-wrapper'>
                {this.props.title ? (
                  <div className='component-header-title'>
                    {this.props.title}
                  </div>
                ) : null}
                {this.props.middelChild ? this.props.middelChild : null}
              </div>
              {
                (this.props.rightChild || this.props.showShare) && <div className='component-header-right-wrapper'>
                  {this.props.rightChild ? this.props.rightChild : null}
                  {this.props.showShare ? (
                    <span
                      className='iconfont icon-share component-header-share'
                      onClick={() => this.props.shareCB()}
                    />
                  ) : null}
                </div>
              }
            </div>
            {this.props.extra ? this.props.extra : null}
          </div>
        )}

        <div className='component-header-static'>
          <SafeArea position='top' />
          <div className='component-placeholder'></div>
        </div>
      </div>
    );
  }
}

Header.defaultProps = {
  className: null,
  backCB: function() {
    navBack();
  },
  shareCB: function() {
    bbtNative.share({
      onShared: (type, status) => {
        console.log(
          `通用头部分享成功回调方法的返回值：type:${type}status:${status}`
        );
      }
    });
  },
  title: '',
  showBorder: false,
  showShadow: false,
  showBack: true,
  showShare: true,
  leftChild: null,
  middelChild: null,
  rightChild: null,
  extra: null,
  placeholder: false
};

const mapStateToProps = ({ meta, router }) => ({
  userAgent: meta.userAgent,
  router: router
});

export default connect(mapStateToProps)(Header);
